import React, { useState, useEffect, useRef } from "react"
import {
  Box,
  Button,
  TextField,
} from '@material-ui/core';

import SelectedBlueIcon from "../../images/selected-blue.svg"
import CheckedStepperIcon from "../../images/checked-stepper.svg"
import GeminiWhiteIcon from "../../images/gemini-white.svg"
import HomeWhiteIcon from "../../images/home-white.svg"

import { allQuestions, smoothieTypes } from "../../pages/Home.js"

export const DefaultContainer = ({children}) => {
  return (
    <Box sx={{
      width:"1600px",
      height:"2560px",
      backgroundColor:"background.paper",
      overflow:"hidden",
      display:"flex",
      flexDirection:"column"
    }}>
      {/* HEADER */}
      <Box sx={{ display:"flex", paddingTop:"40px", paddingLeft:"0px", gap:"0px", justifyContent:"center"}}>
        <Box sx={{
          fontSize:"85px",
          fontWeight:"bold",
          color:"text.primary"
        }}>
          Le Search bar par
        </Box>
        <Box sx={{
          width:"520px",
          height:"117px",
          background:"url('./static/logo_noir.png')",
          backgroundSize:"contain",
          backgroundSize:"444px 100px",
          backgroundRepeat:"no-repeat",
          backgroundPosition:"center center",
        }}>

        </Box>
        {/*<Box sx={{
          fontSize:"85px",
          fontWeight:"bold",
          color:"text.primary"
        }}>
          Gemini
        </Box>*/}
      </Box>
      {children}
    </Box>
  )
}

export const Stepper = ({step}) => {
  let nbrStep = 6;
  let activeStyle = {
    width:"130px",
    height:"130px",
    borderRadius:"50%",
    border: "4px solid #E5E7EB",
    background:"#4285F4",
    color:"white",
    fontSize:"50px",
    fontWeight:"bold",
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
  }
  let nextStyle = {
    width:"130px",
    height:"130px",
    borderRadius:"50%",
    border: "2px solid #E5E7EB",
    background:"#F3F4F6",
    color:"#9CA3AF",
    fontSize:"50px",
    fontWeight:"bold",
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
  }
  let okStyle = {
    width:"130px",
    height:"130px",
    borderRadius:"50%",
    border: "0",
    background:"#4285F4",
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
  }
  return (
    <Box sx={{width:"100%", paddingLeft:"108px", paddingRight:"108px", paddingTop:"75px"}}>
      <Box sx={{width:"100%", height:"130px", position:"relative"}}>
        <Box sx={{position:"relative", width:"100%", height:"6px", background:"#E5E7EB", top:"61px"}} />
        <Box sx={{position:"relative", top:"-6px", display:"flex", justifyContent:"space-between"}}>
          {[...Array(nbrStep)].map((elem, index) => {
            if (index+1 === step) { //active
              return (
                <Box key={index} sx={activeStyle}>
                  {index+1}
                </Box>
              )
            } else if (index+1 < step) {
              return (
                <Box key={index} sx={okStyle}>
                  <img src={CheckedStepperIcon} />
                </Box>
              )
            } else if (index+1 > step) {
              return (
                <Box key={index} sx={nextStyle}>
                  {index+1}
                </Box>
              )
            }
          })}
        </Box>
      </Box>
    </Box>
  )
}

export const TitleAndSubTitle = ({title, subTitle, withHello, reps}) => {
  return (
    <Box sx={{
      display:"flex",
      flexDirection:"column",
      gap:withHello?"10px":"90px",
      paddingTop:withHello?"200px":"250px",
    }}>
      {withHello &&
        <>
          <Box sx={{
            fontSize:"90px",
            fontWeight:"600",
            color:"primary.main",
            textAlign:"center"
          }}>
            Bonjour,
          </Box>
          <Box sx={{
            fontSize:"90px",
            fontWeight:"600",
            color:"text.primary",
            textAlign:"center",
            textTransform:"capitalize"
          }}>
            {reps?.name}
          </Box>
          <Box sx={{height:"40px"}}>
          </Box>
        </>
      }
      {title ? (
        <Box sx={{
          fontSize:"90px",
          fontWeight:"600",
          color:"text.primary",
          textAlign:"center"
        }}>
          {title}
        </Box>
      ) : (
        <Box sx={{height:"113px"}} />
      )}
      <Box sx={{
        fontSize:title?"50px":"65px",
        fontWeight:title?"500":600,
        color:"text.primary",
        textAlign:"center",
        minHeight:"120px"
      }}>
        {subTitle}
      </Box>
    </Box>
  )
}

export const Footer = ({disabled, onClick, returnToHome}) => {
  return (
    <Box sx={{textAlign:"center", paddingTop:"50px", paddingBottom:"50px"}}>
      <Button
        variant="contained"
        disabled={disabled}
        onClick={onClick}
      >
        <Box sx={{display:"flex", gap:"12px"}}>
          {returnToHome === true ? (
            <>
              <img src={HomeWhiteIcon} />Retour à l'accueil
            </>
          ) : (
            <>
              Suivant
            </>
          )}
        </Box>
      </Button>
    </Box>
  )
}

const Step1 = ({step, setStep, reps, setReps}) => {

  const textFieldRef = useRef(null)

  useEffect(() => {
    if (textFieldRef?.current) {
      console.log("on focus l'input")
      textFieldRef?.current?.focus()
    }
  }, [])

  return (
    <>
      <DefaultContainer>
        {/*<Stepper step={step}/>*/}

        <TitleAndSubTitle
          withHello
          reps={reps}
          title={allQuestions?.step1?.title}
          subTitle={allQuestions?.step1?.subTitle}
        />

        {/* CENTER */}
        <Box sx={{flex:1, marginTop:"180px", display:"flex", justifyContent:"center", paddingLeft:"60px", paddingRight:"60px"}}>
          <Box sx={{width:"100%", display:"flex", flexDirection:"row", flexWrap:"wrap", gap:"50px", alignContent:"flex-start"}}>
            {allQuestions?.step1?.questions?.map((elem, index) => {
              let selected = false
              if (index === reps?.q1) { selected = true }
              return (
                <Box
                  key={index}
                  onClick={() => {
                    setReps({...reps, q1 : index})
                  }}
                  sx={{
                    flexBasis:'calc(50% - 25px)',
                    flexShrink:0,
                    height:"400px",
                    background: selected ? "black" : "#F3F3F6",
                    border: selected ? "4px solid black" : "3px solid #C7C4D7",
                    boxShadow: selected ? "0px 10px 30px rgba(93, 95, 239, 0.12)" : "",
                    borderRadius: "24px",
                    //cursor:"pointer",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"center",
                    position:"relative"
                  }}
                >
                  {selected &&
                    <Box sx={{
                      position:"absolute",
                      width:"47px",
                      height:"47px",
                      top:"20px",
                      right:"20px",
                    }}>
                      <img src={SelectedBlueIcon} />
                    </Box>
                  }
                  <Box sx={{display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:"40px"}}>
                    <Box sx={{
                      width:"140px",
                      height:"140px",
                      background:selected ? "#4285F4" : "#E8E8EA",
                      borderRadius:"50%",
                      display:"flex",
                      justifyContent:"center",
                      alignItems:"center",
                      color: selected ? "white" : "primary.main",
                    }}>
                      {elem?.icon}
                    </Box>
                    <Box sx={{
                      fontSize:"53px",
                      fontWeight:"600",
                      color : selected ? "white" : "text.primary",
                      textAlign:"center",
                    }}>
                      {elem?.title}
                    </Box>
                    {elem?.subTitle &&
                      <Box sx={{
                        fontSize:"23px",
                        fontWeight:"500",
                        color : selected ? "white" : "#464555",
                        textAlign:"center",
                      }}>
                        {elem?.subTitle}
                      </Box>
                    }
                  </Box>
                </Box>
              )
            })}
          </Box>
        </Box>

        <Footer
          onClick={() => { setStep(2) }}
          disabled={reps?.q1 === null}
        />

      </DefaultContainer>
    </>
  );
};

export default Step1;
